module.exports = __webpack_public_path__ + "img/img_applicable_06.749ebd42.png";